module.exports = __webpack_public_path__ + "img/banner.e10449c6.jpg";